<template>
  <v-dialog
    v-model="model"
    :width="$vuetify.breakpoint.mdAndUp ? '600px' : ''"
  >
    <v-card @keyup.enter="doLogin">
      <v-card-title class="pa-0 mb-3">
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title
            class="accent--text headline"
          >
            Reauthentication Required
          </v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-alert
          color="info"
          icon="info"
        >
          This operation is sensitive and requires recent authentication.
          Log in again before retrying this request.
        </v-alert>
        <v-text-field
          id="email"
          disabled
          type="email"
          :value="getAuthUser.email"
          label="Email"
        />
        <v-text-field
          id="password"
          v-model="password"
          type="password"
          label="Password"
        />
      </v-card-text>

      <v-divider class="my-3" />

      <v-card-actions>
        <v-spacer />
        <v-btn
          :diabled="isLoading"
          text
          rounded
          @click="model = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="isLoading"
          color="primary"
          rounded
          outlined
          @click="doLogin"
        >
          Authenticate
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([ 'getAuthUser', 'getReloginDialog' ]),
    model: {
      get() {
        return this.getReloginDialog
      },
      set(val) {
        this.setReloginDialog(val)
      }
    }
  },
  data() {
    return {
      isLoading: false,
      identity: '',
      password: ''
    }
  },
  methods: {
    ...mapActions([ 'login', 'setReloginDialog' ]),
    async doLogin() {
      this.isLoading = true
      await this.login({
        _redirect: false,
        identity: this.getAuthUser.email,
        password: this.password
      })
        .then(() => {
          this.model = false
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
